export let VIDEO_CARDS_BI_ORIGIN;
(function (VIDEO_CARDS_BI_ORIGIN) {
  VIDEO_CARDS_BI_ORIGIN["VIDEO"] = "video";
  VIDEO_CARDS_BI_ORIGIN["ALL_CARDS"] = "all_cards";
})(VIDEO_CARDS_BI_ORIGIN || (VIDEO_CARDS_BI_ORIGIN = {}));
//# sourceMappingURL=video-cards-origin.js.map